import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/no-noninteractive-element-interactions */
import React, { useMemo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import checkMarkWhiteIcon from 'assets/icons/checkmark-white.svg';
import { useHits } from 'react-instantsearch';
import { connectInfiniteHits, connectStateResults } from 'commons/react-instantsearch-dom-wrappers';
import { isEmpty } from 'lodash';
import avo from 'analytics/avo';
import CustomerReviewCard from 'components/consumer/customer-reviews-list/CustomerReviewCard';
import ProductCatalogCard from 'components/consumer/associate/ProductCatalogCard';
import ExpandableItemsList from 'components/consumer/ExpandableItemsList';
import JBImage from 'components/essentials/JBImage';
import Checkbox from 'components/consumer/Checkbox';
import { SelectedFilter } from 'components/consumer/inspiration-photos-grid/search-state/utils';
import { ALGOLIA_INDEX_NAME, COLOR_CODES_FABRIC, MATERIAL_CODES } from 'commons/constants';
import useScreen from 'hooks/useScreen';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import useStaticProductListingPageData from 'hooks/useStaticProductListingPageData';
import useProductVariantsToShow from 'hooks/useProductListingData/useProductVariantsToShow';
import ProductCardPriceUI from 'components/consumer/product-card/ProductCardPrice/ProductCardPriceUI';
import useSearchUrlQueryParams from '../advanced-search/hooks/useSearchUrlQueryParams';
import { productHitsOptionColorMatch as productHitsOptionColorMatchStatic } from '../instant-search/components/StaticProductResults';
import { getVariantsByMatchedColorFirst } from '../advanced-search-next/components/AdvancedSearchProductHits/utils';
let productTypes = [];
let ALL_OPTIONS_BY_COLOR = null;

// TODO: CON-7887: (Codemod generated): ensure your usage correctly maps the props from the connector to the hook
function connectHits(Component) {
  const Hits = props => {
    const $ = _c(3);
    const data = useHits(props);
    let t0;
    if ($[0] !== data || $[1] !== props) {
      t0 = <Component {...props} {...data} />;
      $[0] = data;
      $[1] = props;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  };
  return Hits;
}
const getAllOptionsByColor = (allOptionsValues = {}) => {
  if (!ALL_OPTIONS_BY_COLOR && !isEmpty(allOptionsValues)) {
    ALL_OPTIONS_BY_COLOR = {};
    Object.keys(allOptionsValues || {}).forEach(val => {
      const optionValue = allOptionsValues[val];
      if (optionValue.color) {
        if (!ALL_OPTIONS_BY_COLOR[optionValue.color]) {
          ALL_OPTIONS_BY_COLOR[optionValue.color] = [];
        }
        ALL_OPTIONS_BY_COLOR[optionValue.color].push(optionValue);
      }
    });
  }
  return ALL_OPTIONS_BY_COLOR;
};
export const productIndexes = [ALGOLIA_INDEX_NAME.PRODUCTS, ALGOLIA_INDEX_NAME.PRODUCTS_PRICE_ASC, ALGOLIA_INDEX_NAME.PRODUCTS_PRICE_DESC, ALGOLIA_INDEX_NAME.PRODUCTS_NAME_ASC, ALGOLIA_INDEX_NAME.PRODUCTS_GOLIVE_DATE_DESC];
export const CATEGORY_INDEX_MAPPING = {
  products: ALGOLIA_INDEX_NAME.PRODUCTS,
  categories: 'categories',
  pages: ALGOLIA_INDEX_NAME.STATIC_PAGES,
  reviews: 'reviews',
  'customer photos': 'customer_photos'
};
const ALGOLIA_INDEX_CATEGORY_MAPPING = {
  [ALGOLIA_INDEX_NAME.PRODUCTS]: 'products',
  [ALGOLIA_INDEX_NAME.STATIC_PAGES]: 'pages',
  [ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS]: 'customer photos',
  [ALGOLIA_INDEX_NAME.REVIEWS]: 'reviews',
  [ALGOLIA_INDEX_NAME.CATEGORIES]: 'categories'
};
const productHitsOptionColorMatch = productHits => {
  if (!productHits?.length) {
    return null;
  }
  let matchedColorCode = null;
  const firstHit = productHits[0];
  if (firstHit?._highlightResult?.option_color) {
    const {
      option_color
    } = firstHit._highlightResult;
    const optionColorEntries = firstHit.option_color || [];
    let colorIdx = 0;
    for (const optColor of option_color) {
      if (optColor?.matchedWords?.length) {
        if ((optionColorEntries[colorIdx] || '').toLowerCase().trim() === optColor.matchedWords[0].toLowerCase().trim()) {
          matchedColorCode = optionColorEntries[colorIdx];
          break;
        }
      }
      colorIdx += 1;
    }
  }
  return matchedColorCode;
};
const getOverridesProps = (productHits, allOptionsValues, colorFiltered) => {
  const allOptionsByColor = allOptionsValues ? getAllOptionsByColor(allOptionsValues) : null;
  const productHitsOptionQueryMatch = productHitsOptionColorMatch(productHits);
  if (!colorFiltered?.currentColor?.length && !productHitsOptionQueryMatch) {
    return {};
  }
  const finalAllOptionsByColor = colorFiltered?.currentColor?.length ? colorFiltered.currentColor[0] : productHitsOptionQueryMatch;
  return productHits.reduce((acc, hit) => {
    const hitOptionValue = allOptionsByColor?.[finalAllOptionsByColor]?.find(colorOpt => hit.option_value?.includes(colorOpt.value))?.value ?? '';
    const optionName = ['Fabric', 'Leather', 'Wood', 'Wood Stain', 'Frame'].includes(hit.default_material_type) ? hit.default_material_type : '';
    return {
      ...acc,
      [hit.product_id]: {
        forMaterial: hitOptionValue,
        forMaterialType: optionName
      }
    };
  }, {});
};
const sendData = (query, productIDs, productSkus, otherProps) => {
  if (!productIDs || !productIDs.length) {
    return;
  }
  /*
  get top 3 results and send them to analytics .
  Send only once per query as this part of the code gets called several times.
  To do that ,check with query if it has changed .
  Sometimes query remains same but the search results change.
  in both cases,send data to analytics.
  In this function,we are also setting the last query and top 3 results to the state as well.
  These state values help us identify if query changed or result changed etc.
  */
  const topThreeRes = productIDs.slice(0, 3);
  if (query !== '' && otherProps.lastQuery !== query) {
    otherProps.setLastQuery(query);
    otherProps.setLastQueryTopThreeRes(topThreeRes);
  } else if (otherProps.lastQuery === query && JSON.stringify(otherProps.lastQueryTopThreeRes) !== JSON.stringify(topThreeRes)) {
    otherProps.setLastQueryTopThreeRes(topThreeRes);
  }
  otherProps.setInactive(false);
};
export const getBlogPath = url => {
  const blogPost = url.split('/').filter(v => !!v).pop();
  return `/blog/${blogPost}`;
};
export const getAdvancedSearchUrlForQueryAndIndex = (query = '', index = 'products_jb4', facetVal) => {
  const safeQuery = query ?? '';
  return `/search/?category=${encodeURIComponent(index.indexOf('products') !== -1 ? 'products_jb4' : index)}&q=${encodeURIComponent(safeQuery) || ''}&filter=${encodeURIComponent(facetVal || '*')}`;
};
const ResultsHeader = t0 => {
  const $ = _c(7);
  const {
    variant: t1,
    children
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const t2 = variant === "advanced-search";
  const t3 = variant !== "mobile";
  const t4 = variant === "mobile";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = classNames("mx-0 my-2.5 text-base font-bold", {
      "hidden lg:block": t2,
      "text-gray": t3,
      "text-brand block mt-[15px] mb-[7px]": t4
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== children || $[5] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[4] = children;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
ResultsHeader.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export const ProductResultsMobile = connectStateResults(({
  searchState,
  searchResults,
  refine,
  isInstantSearch,
  layout,
  searching,
  allOptionsData = {},
  ...otherProps
}) => {
  const {
    hits
  } = isInstantSearch ? searchResults : otherProps;
  const productIDs = hits.map(hit => parseInt(hit.product_id, 10));
  const productSkus = hits.map(hit => hit.serial_number);
  const currentPage = useUserCurrentPageType();

  // CN-533 Search data to GTM
  if (otherProps.inactive) {
    sendData(searchState.query, productIDs, productSkus, otherProps);
  }
  const overrideProps = useMemo(() => getOverridesProps(hits, allOptionsData?.allOptionsValues, null), [hits, allOptionsData?.allOptionsValues]);
  const colorFacetQuery = productHitsOptionColorMatchStatic(hits);
  const instantSearchStaticData = useStaticProductListingPageData({
    productIds: productIDs,
    serverSidePaginationEnabled: true
  }, {
    onlyShowValidFilters: true
  });
  const productsWithColoredVariants = useProductVariantsToShow({
    colorFilters: colorFacetQuery?.length > 0 ? colorFacetQuery : null,
    products: instantSearchStaticData.products
  });
  const instantSearchProductsData = useMemo(() => colorFacetQuery?.length > 0 ? productsWithColoredVariants.slice(0, 3) : instantSearchStaticData?.products?.slice(0, 3) ?? [], [colorFacetQuery, productsWithColoredVariants, instantSearchStaticData]);
  const productsWithHighlightedVariantsFirst = useMemo(() => instantSearchProductsData.map(product => ({
    ...product,
    variantsToShow: getVariantsByMatchedColorFirst(product, hits)
  })), [instantSearchProductsData, hits]);
  const handleProductClick = useCallback(() => {
    avo.productsSearched({
      query: searchState.query,
      location: currentPage,
      searchTarget: avo.SearchTarget.PRODUCT_GRID
    });
    otherProps.toggleMenu?.();
    otherProps.toggleSearchOpen?.();
  }, [searchState.query, currentPage, otherProps]);
  if (isInstantSearch && !productIDs.length) {
    return null;
  }
  return <div className="instant-search-form__product-results flex-1 [border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 [&_.ais-Hits-list]:flex [&_.ais-Hits-item]:p-2.5">
        <ResultsHeader variant="mobile">
          {otherProps.forComponent === 'mobile' ? 'Results' : 'Products'}
        </ResultsHeader>
        {productsWithHighlightedVariantsFirst?.map(product => <Link onClick={handleProductClick} to={`${product.variantsToShow?.[0].path ?? ''}`} className="text-base flex items-center font-bold text-gray px-0 py-4 [border-bottom:1px_solid_#f1f1f1] no-underline last:[border-bottom:0] [&_img]:object-contain [text-decoration:none]" key={product.id}>
            <div className="mr-4 w-[100px] flex justify-center items-center">
              <JBImage className="object-contain m-5 opacity-100 max-h-full max-w-full" fit="clip" height={265} width={265} lazy={false} loader={false} src={`${product.variantsToShow?.[0].image ?? ''}`} trim="color" trimPad={20} {...overrideProps[product.id]} />
            </div>
            <div>
              {product.name}
              <ProductCardPriceUI originalPrice={product.variantsToShow?.[0].originalPrice} salePrice={product.variantsToShow?.[0].price} />
            </div>
          </Link>)}
        {isInstantSearch && <div className="flex mt-5 justify-start [&_a]:[text-decoration:none]">
            <SeeAllButton toggleSearchOpen={otherProps.toggleSearchOpen} variant="mobile" />
          </div>}
      </div>;
});
export const StoreCatalogProductResults = connectInfiniteHits((props = {}) => {
  const {
    windowWidth
  } = useScreen();
  const infiniteScrollThreshold = windowWidth <= 768 ? '2800px' : '2200px';
  const {
    hits,
    hasMore,
    onLoadMore
  } = props;
  const productsList = hits && hits.length > 0 ? hits.map(hit => <ProductCatalogCard product={hit} />) : [];
  return <div className="catalog-search-results">
      <div className="text-sm grid [border-bottom:1px_solid_#e5e5e5] mt-8 mr-0 mb-4 ml-8 font-normal w-full grid-cols-[29rem_1fr_1fr_1fr] max-[1023px]:hidden">
        <div className="catalog-search-results__header-product">Active</div>
        <div>SKU</div>
        <div>Shipping(Custom)</div>
        <div>Stock</div>
      </div>
      <div className="flex w-full overflow-hidden [&_.infinite-scroll-component]:!overflow-hidden [&_.infinite-scroll-component]:w-full [&>div]:w-full">
        <InfiniteScroll dataLength={productsList.length} next={onLoadMore} hasMore={hasMore} scrollThreshold={infiniteScrollThreshold} loader="Loading...">
          {productsList}
        </InfiniteScroll>
      </div>
    </div>;
});
export const ReviewsResults = connectInfiniteHits(({
  hits,
  hasMore,
  refine,
  variant = 'advanced-search',
  ...otherProps
}) => {
  const {
    windowWidth
  } = useScreen();
  const infiniteScrollThreshold = windowWidth <= 768 ? '2800px' : '2200px';
  const reviewsList = hits.map(hit => <CustomerReviewCard key={hit.review_id} productReview={hit} type="search" variant="advanced-search" />);
  return <>
        <ResultsHeader variant={variant}>
          {otherProps.forComponent === 'mobile' ? 'Results' : 'Reviews'}
        </ResultsHeader>

        <InfiniteScroll dataLength={reviewsList.length} next={otherProps.onLoadMore} hasMore={hasMore} scrollThreshold={infiniteScrollThreshold} loader={<h4>Loading...</h4>}>
          <div data-xc="reviews-list-container">{reviewsList}</div>
        </InfiniteScroll>
      </>;
});
export const PagesResults = connectInfiniteHits(({
  hits,
  hasMore,
  refine,
  variant = 'desktop',
  ...otherProps
}) => {
  const {
    windowWidth
  } = useScreen();
  const infiniteScrollThreshold = windowWidth <= 768 ? '2800px' : '2200px';
  const pagesList = hits.map(hit => {
    if (!hit?.url) {
      return null;
    }
    let finalURL = <Link onClick={async () => {
      if (otherProps.isInstantSearch) {
        await otherProps.toggleSearchOpen();
      }
      avo.productsSearched({
        query: otherProps?.query ?? '',
        location: otherProps?.currentPage,
        searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
      });
    }} to={(hit.url || '').startsWith('/') ? hit.url : `/${hit.url}`}>
            {hit.url}
          </Link>;
    if (hit.url && hit.url.startsWith('/stories')) {
      finalURL = <Link onClick={async () => {
        if (otherProps.isInstantSearch) {
          await otherProps.toggleSearchOpen();
        }
        avo.productsSearched({
          query: otherProps?.query ?? '',
          location: otherProps?.currentPage,
          searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
        });
      }} to={getBlogPath(hit.url)}>
              {getBlogPath(hit.url)}
            </Link>;
    }
    return <div className="flex flex-col bg-gray-light8 p-8 mb-8 text-gray">
            <div className="text-[1.2rem] leading-[2rem] no-underlinetracking-[-.02em] mt-0 mx-0 mb-[1.1rem] font-normal text-gray">
              {hit.title || hit.name}
            </div>
            <div className="font-normal text-gray text-base leading-[1.5rem] flex flex-col items-start text-[.8rem]">
              {hit.meta_description || hit.description}
            </div>
            <div className="no-underline text-[.8rem] cursor-pointer [&_a]:text-brand">
              {finalURL}
            </div>
          </div>;
  }).filter(Boolean);
  if (otherProps.isInstantSearch) {
    return <div className="instant-search-form__pages-results [border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10">
          <ResultsHeader variant={variant}>
            {otherProps.forComponent === 'mobile' ? 'Results' : 'Pages'}
          </ResultsHeader>
          {pagesList.slice(0, 3)}
        </div>;
  }
  return <>
        <ResultsHeader variant={variant}>
          {otherProps.forComponent === 'mobile' ? 'Results' : 'Pages'}
        </ResultsHeader>

        <InfiniteScroll dataLength={pagesList.length} next={otherProps.onLoadMore} hasMore={hasMore} scrollThreshold={infiniteScrollThreshold} loader={<h4>Loading...</h4>}>
          {pagesList}
        </InfiniteScroll>
      </>;
});
export const SeeAllButton = connectStateResults(({
  searchResults,
  variant = 'desktop',
  ...otherProps
}) => {
  if (!searchResults || !searchResults.query) {
    return null;
  }
  const currentPage = useUserCurrentPageType();
  return <Link onClick={async () => {
    if (otherProps && otherProps.toggleSearchOpen) await otherProps.toggleSearchOpen();
    avo.productsSearched({
      query: searchResults.query,
      location: currentPage,
      searchTarget: avo.SearchTarget.FULL_RESULTS
    });
  }} to={getAdvancedSearchUrlForQueryAndIndex(searchResults.query, 'products')}>
        <div className={classNames('p-2.5 border-solid border-gray cursor-pointer font-bold tracking-[-.0125rem] leading-[1.45rem] text-base bg-gray', {
      'text-center w-[200px] h-[50px] border-2 text-white': variant === 'desktop',
      'text-left w-auto h-auto pt-0 pr-0 pb-0 pl-2.5 border-0 bg-transparent text-gray mr-5': variant === 'mobile'
    })}>
          See full results ({searchResults.nbHits})
        </div>
      </Link>;
});
export const ResultsByCategory = connectStateResults(({
  searchState,
  searching,
  searchResults,
  error,
  allSearchResults,
  isSearchStalled,
  variant = 'desktop',
  ...otherProps
}) => {
  if (!searchState.query || searching || isSearchStalled) {
    return null;
  }
  const queryWord = searchState.query.charAt(0).toUpperCase() + searchState.query.slice(1);
  const currentPage = useUserCurrentPageType();
  return <>
        <ResultsHeader variant={variant}>View results by:</ResultsHeader>
        <div>
          {allSearchResults?.[ALGOLIA_INDEX_NAME.PRODUCTS] && allSearchResults[ALGOLIA_INDEX_NAME.PRODUCTS].nbHits !== 0 ? <Link to={getAdvancedSearchUrlForQueryAndIndex(searchState.query, 'products')} onClick={async () => {
        await otherProps.toggleSearchOpen();
        avo.productsSearched({
          query: searchState.query,
          location: currentPage,
          searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
        });
      }} className={classNames('text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8', {
        'block mr-2.5 text-[#585858]': variant === 'desktop',
        'text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block': variant === 'mobile'
      })}>
              Products ({allSearchResults[ALGOLIA_INDEX_NAME.PRODUCTS].nbHits})
            </Link> : ''}
          {allSearchResults?.[ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS] && allSearchResults[ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS].nbHits !== 0 ? <Link to={getAdvancedSearchUrlForQueryAndIndex(searchState.query, 'customer_photos')} onClick={async () => {
        await otherProps.toggleSearchOpen();
        avo.productsSearched({
          query: searchState.query,
          location: currentPage,
          searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
        });
      }} className={classNames('text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8', {
        'block mr-2.5 text-[#585858]': variant === 'desktop',
        'text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block': variant === 'mobile'
      })}>
              {queryWord} in Customer Photos (
              {allSearchResults[ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS].nbHits})
            </Link> : ''}

          {allSearchResults?.[ALGOLIA_INDEX_NAME.REVIEWS] && allSearchResults[ALGOLIA_INDEX_NAME.REVIEWS].nbHits !== 0 ? <Link to={getAdvancedSearchUrlForQueryAndIndex(searchState.query, 'reviews')} onClick={async () => {
        await otherProps.toggleSearchOpen();
        avo.productsSearched({
          query: searchState.query,
          location: currentPage,
          searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
        });
      }} className={classNames('text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8', {
        'block mr-2.5 text-[#585858]': variant === 'desktop',
        'text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block': variant === 'mobile'
      })}>
              {queryWord} in Reviews (
              {allSearchResults[ALGOLIA_INDEX_NAME.REVIEWS].nbHits})
            </Link> : ''}
          {allSearchResults?.[ALGOLIA_INDEX_NAME.STATIC_PAGES] && allSearchResults[ALGOLIA_INDEX_NAME.STATIC_PAGES].nbHits !== 0 ? <Link to={getAdvancedSearchUrlForQueryAndIndex(searchState.query, 'static_pages_new')} onClick={async () => {
        await otherProps.toggleSearchOpen();
        avo.productsSearched({
          query: searchState.query,
          location: currentPage,
          searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
        });
      }} className={classNames('text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8', {
        'block mr-2.5 text-[#585858]': variant === 'desktop',
        'text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block': variant === 'mobile'
      })}>
              {queryWord} in Pages (
              {allSearchResults[ALGOLIA_INDEX_NAME.STATIC_PAGES].nbHits})
            </Link> : ''}
        </div>
      </>;
});
export const SearchResults = connectStateResults(({
  searchState,
  children
}) => {
  if (!searchState.query) {
    return null;
  }
  return children;
});
export const ChangeToNextPopulatedIndex = connectStateResults(({
  allSearchResults,
  searching,
  currentIndex,
  indexChange
}) => {
  if (!allSearchResults || searching || !currentIndex) {
    return null;
  }
  const currentIndexResults = allSearchResults[currentIndex];
  if (currentIndexResults && !currentIndexResults?.nbHits) {
    const indexToChangeTo = Object.values(ALGOLIA_INDEX_NAME).find(indexName => indexName !== currentIndex && allSearchResults[indexName]?.hits?.length);
    if (indexToChangeTo) {
      indexChange(ALGOLIA_INDEX_CATEGORY_MAPPING[indexToChangeTo]);
    }
  }
  return null;
});
export const SearchCount = connectStateResults(({
  searchResults,
  title,
  indexClick,
  selectedOption,
  invalidProductIdsCount,
  id
}) => {
  if (!searchResults || searchResults?.nbHits === 0) {
    return null;
  }
  const finalResultCount = title === 'Products' && invalidProductIdsCount ? searchResults.nbHits - invalidProductIdsCount : searchResults.nbHits;
  const isSelected = selectedOption === id;
  return searchResults ? <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand">
        <button type="button" className={classNames('w-full bg-white text-center lg:text-left', {
      'font-bold': isSelected
    })} onClick={() => {
      if (finalResultCount) indexClick(title.toLowerCase());
    }}>
          {`${title} (${finalResultCount})`}
        </button>
      </div> : '';
});
const StaticPageHit = t0 => {
  const $ = _c(7);
  const {
    hits: t1,
    variant: t2,
    ...otherProps
  } = t0;
  const hits = t1 === undefined ? [] : t1;
  const variant = t2 === undefined ? "desktop" : t2;
  const {
    queryUrlParam: query
  } = useSearchUrlQueryParams();
  const currentPage = useUserCurrentPageType();
  if (!hits.length) {
    return null;
  }
  const t3 = "[border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 static-pages";
  let t4;
  if ($[0] !== variant) {
    t4 = <ResultsHeader variant={variant}>Pages</ResultsHeader>;
    $[0] = variant;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = hits.map(hit => {
    const isStoriesURL = (hit?.url || "").startsWith("/stories");
    const finalURL = isStoriesURL ? getBlogPath(hit.url) : hit.url;
    if (isStoriesURL) {
      return <div key={hit.objectID}><Link className={classNames("text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8", {
          "block mr-2.5 text-[#585858]": variant === "desktop",
          "text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block": variant === "mobile"
        })} onClick={async () => {
          await otherProps.toggleSearchOpen();
          avo.productsSearched({
            query,
            location: currentPage,
            searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
          });
        }} to={finalURL}>{hit.page}</Link></div>;
    }
    return <div key={hit.objectID}><Link className={classNames("text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8", {
        "block mr-2.5 text-[#585858]": variant === "desktop",
        "text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block": variant === "mobile"
      })} onClick={async () => {
        await otherProps.toggleSearchOpen();
        avo.productsSearched({
          query,
          location: currentPage,
          searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
        });
      }} to={finalURL}>{hit.page}</Link></div>;
  });
  let t6;
  if ($[2] !== t5) {
    t6 = <div>{t5}</div>;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t4 || $[5] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[4] = t4;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
};
StaticPageHit.propTypes = {
  hits: PropTypes.array,
  variant: PropTypes.string
};
export const StaticPageHits = connectHits(StaticPageHit);
const CategoryHit = t0 => {
  const $ = _c(10);
  const {
    hits,
    variant: t1,
    ...otherProps
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const {
    queryUrlParam: query
  } = useSearchUrlQueryParams();
  const currentPage = useUserCurrentPageType();
  if (!hits.length) {
    return null;
  }
  const t2 = variant === "mobile";
  let t3;
  if ($[0] !== t2) {
    t3 = classNames("[border-right:1px_solid_#f1f1f1] pt-5 pr-8 pb-10 min-w-[20%] flex-[0_1_20%] pl-[30px] h-full min-h-[264px]", {
      "!p-0 min-h-[auto] mb-2 w-full border-0 order-[-1]": t2
    });
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== variant) {
    t4 = <ResultsHeader variant={variant}>Categories</ResultsHeader>;
    $[2] = variant;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = hits.map(hit => {
    const highlightedCategory = hit?._highlightResult?.category_name?.value || "";
    const categoryLabelRaw = hit?.category_name || highlightedCategory.replace(/<[^>]+>/g, "");
    const categoryLabel = categoryLabelRaw?.trim();
    if (!categoryLabel) {
      return null;
    }
    const categoryUrl = hit.category_sef_url || hit.url || `/categories/${categoryLabel.toLowerCase().replace(/\s+/g, "-")}`;
    return <div key={hit.objectID}><Link className={classNames("text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8", {
        "block mr-2.5 text-[#585858]": variant === "desktop",
        "text-sm px-2 py-1 rounded-[3px] text-gray font-bold mr-2.5 bg-gray-light9 inline-block": variant === "mobile"
      })} onClick={async () => {
        await otherProps.toggleSearchOpen();
        avo.productsSearched({
          query,
          location: currentPage,
          searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
        });
      }} to={categoryUrl}>{categoryLabel}</Link></div>;
  });
  let t6;
  if ($[4] !== t5) {
    t6 = <div>{t5}</div>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
CategoryHit.propTypes = {
  hits: PropTypes.array,
  variant: PropTypes.string
};
export const CategoryHits = connectHits(CategoryHit);
export const ResultHeaderSummary = connectStateResults(({
  indexName,
  searchResults,
  invalidProductIds = [],
  countOverride = null,
  queryOverride = null
}) => {
  const finalQuery = queryOverride ?? searchResults?.query ?? '';
  if (!finalQuery) {
    return null;
  }
  const finalResultCount = Number.isFinite(countOverride) ? countOverride : indexName?.includes('products') && invalidProductIds.length ? searchResults.nbHits - invalidProductIds.length : searchResults?.nbHits ?? 0;
  return <h1 className={classNames('text-2xl font-bold scale-100 [transform-origin:left_center] [transition:transform_.2s_ease_0s] mb-0 max-[1023px]:text-xl max-[1023px]:font-bold max-[1023px]:mt-5 max-[1023px]:mb-4 max-[1023px]:mx-4 md:flex md:gap-5 md:items-center', '[&_span]:text-sm [&_span]:font-normal [&_span]:text-gray-light2')}>
        Results for &quot;{finalQuery}&quot;{' '}
        <span className="text-sm text-gray-light2 md:relative md:self-center font-normal self-center relative" data-xc="search-results-count">
          {finalResultCount} Results
        </span>
      </h1>;
});
export const FurnituresFilter = connectStateResults(({
  searchResults,
  onChange,
  typeFiltered
}) => {
  if (!searchResults || !searchResults._rawResults[0].facets.type) {
    return null;
  }
  productTypes = !typeFiltered.isFiltered ? searchResults._rawResults[0].facets.type : productTypes;
  return <>
        <div className="text-base font-bold text-gray px-0 py-4">Furniture</div>

        <div className="space-y-2">
          <ExpandableItemsList>
            {Object.keys(productTypes).map(type => <Checkbox key={type} onClick={() => {
          onChange([{
            label: type
          }]);
        }} checked={type === typeFiltered.currentType} id={type} size="sm">
                {type}
              </Checkbox>)}
          </ExpandableItemsList>
        </div>
      </>;
});
export const OtherFilters = connectStateResults(({
  searchResults,
  onMaterialChange,
  isMaterialFiltered,
  selectedFiltersList,
  clearAllFilters,
  handleRemoveFilter
}) => {
  if (!searchResults) {
    return null;
  }
  return <div className="mt-2 text-left lg:mt-0 lg:sticky lg:top-0">
        {selectedFiltersList.length ? <div className="flex flex-row justify-between pb-2 border-b-[1px] border-b-gray-light7 align-baseline">
            <div>
              <h4 className="text-base font-medium text-gray m-0">
                Filters Results:
              </h4>
            </div>

            <button type="button" className="text-sm hover:text-gray-dark" onClick={clearAllFilters}>
              Clear Filters
            </button>
          </div> : null}
        <div className={classNames('text-sm font-bold items-start flex flex-row flex-wrap justify-start', {
      'min-h-[20px] pt-2': selectedFiltersList.length > 0
    })}>
          {selectedFiltersList.length > 0 ? selectedFiltersList.map(filter => <SelectedFilter filterName={filter.filterName} onDeselect={handleRemoveFilter} name={filter.name} type={filter.type} />) : null}
        </div>
        <div>
          <div>
            {MATERIAL_CODES && <>
                <h3 className="text-base">Materials</h3>
                <div className="mb-4 text-base font-normal max-lg:overflow-x-hidden">
                  <div className="space-y-2">
                    {MATERIAL_CODES.map(material => {
                const key = Object.keys(material)[0];
                return <Checkbox key={key} onClick={() => onMaterialChange(key)} checked={!!isMaterialFiltered[key]} id={key.id} size="sm">
                          {material[key]}
                        </Checkbox>;
              })}
                  </div>
                </div>
              </>}
          </div>
        </div>
      </div>;
});
export const ColorFilter = connectStateResults(({
  searchResults,
  onColorChange,
  colorFiltered
}) => {
  if (!searchResults) {
    return null;
  }
  return <div className="flex flex-row items-center mr-[25px]">
        <ul className="list-none flex flex-row m-0">
          {COLOR_CODES_FABRIC.map(colorValue => {
        const key = Object.keys(colorValue)[0];
        if (key === 'beige/white') return null;
        if (key === 'purple') return null;
        const isColorActive = colorFiltered.currentColor.indexOf(`${key[0].toUpperCase()}${key.substr(1)}`) > -1;
        return <li key={key} onClick={() => {
          onColorChange(`${key[0].toUpperCase()}${key.substr(1)}`);
        }} className={classNames('flex items-center justify-center cursor-pointer px-1 py-0', 'last:pr-0', '[&_span]:w-5 [&_span]:h-5 [&_span]:rounded-full [&_span]:inline-block [&_span]:[background-position:50%]', {
          'border-2 border-solid border-gray': isColorActive
        })}>
                <span className={classNames({
            'border border-solid border-gray': key === 'white' || isColorActive
          })} style={{
            background: colorValue[key]
          }} />

                <JBImage className={classNames('absolute', {
            'opacity-0': !isColorActive,
            'opacity-100': isColorActive
          })} src={checkMarkWhiteIcon} width={10} height={10} />
              </li>;
      })}
        </ul>
      </div>;
});
const sortDescending = (a, b) => {
  if (a.count < b.count) return 1;
  if (b.count < a.count) return -1;
  return 0;
};

/*
 *  Mobile Search Dropdown List
 */
export const MobileSearchOptions = connectStateResults(({
  searchResults
}) => {
  if (!searchResults) {
    return null;
  }
  let productsFacet = [];
  let materialsFacet = [];
  productsFacet = searchResults.getFacetValues('type', {
    sortBy(a, b) {
      return sortDescending(a, b);
    }
  });
  materialsFacet = searchResults.getFacetValues('option_name', {
    sortBy(a, b) {
      return sortDescending(a, b);
    }
  });

  // Show only 3 highest results
  if (productsFacet.length > 3) {
    productsFacet.splice(3);
  }
  if (materialsFacet.length > 3) {
    materialsFacet.splice(3);
  }
  return <div className="[&_ul]:list-none [&_ul_a]:no-underline [&_ul_a_li]:px-8 [&_ul_a_li]:py-4 [&_ul_a_li]:bg-gray-light8 [&_ul_a_li]:[border-bottom:1px_solid_#dbdbdb] [&_ul_a_li]:text-[#252729] [&_ul_a_li]:text-center [&_ul_a_li]:text-[.8rem] [&_ul_a:first-child_li]:first:[border-top:1px_solid_#dbdbdb] [&_ul_a:only-child_li]:only:[border-top:0]">
      {searchResults.query.length > 0 ? <ul>
          {productsFacet.map(facet => <Link key={facet.name} to={getAdvancedSearchUrlForQueryAndIndex(searchResults.query, 'products', `type:${facet.name}`)}>
              <li>{`${searchResults.query} in ${facet.name}`}</li>
            </Link>)}
          {materialsFacet.length > 0 ? materialsFacet.map(facet => <Link key={facet.name} to={getAdvancedSearchUrlForQueryAndIndex(searchResults.query, 'products', `option_name:${facet.name}`)}>
                  <li>{`${searchResults.query} in ${facet.name}`}</li>
                </Link>) : null}
        </ul> : null}
    </div>;
});